import { environment } from '@environments/environment';

export abstract class Rescatable {
  static _name;
  static pathRequest = environment.apiGet;
  static pathRequestNet = environment.apiGetNet;
  static pathRequestStatic = environment.apiStatic;
  //static pathRequestStaticDocker = environment.apiDockerProto;
  static pathAbsolute = null;
  static pathRequestIndex = null;
  static pk = 'id';
  static indexes = ['id'];
  static idFacebookSignedRequest = false;

  static getPathRequest<T extends typeof Rescatable>(this: T): string {
    return this.pathRequest;
  }
  constructor(obj: Rescatable) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
}
